export const BRAND_SHADES = [
  "25",
  "50",
  "100",
  "200",
  "300",
  "400",
  "500",
  "600",
  "700",
  "800",
  "900",
  "950",
] as const;

function hexToRgbComponents(hex: string): [number, number, number] | null {
  const result = /^#?([\da-f]{2})([\da-f]{2})([\da-f]{2})$/i.exec(hex);

  if (!result?.[1] || !result[2] || !result[3]) return null;

  return [
    Number.parseInt(result[1], 16),
    Number.parseInt(result[2], 16),
    Number.parseInt(result[3], 16),
  ];
}

function rgbToHsl(r: number, g: number, b: number): [number, number, number] {
  const rn = r / 255;
  const gn = g / 255;
  const bn = b / 255;
  const max = Math.max(rn, gn, bn);
  const min = Math.min(rn, gn, bn);
  let h = 0;
  let s = 0;
  const l = (max + min) / 2;

  if (max !== min) {
    const d = max - min;

    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

    if (max === rn) h = ((gn - bn) / d + (gn < bn ? 6 : 0)) / 6;
    else if (max === gn) h = ((bn - rn) / d + 2) / 6;
    else h = ((rn - gn) / d + 4) / 6;
  }

  return [h * 360, s * 100, l * 100];
}

function hslToRgbString(h: number, s: number, l: number): string {
  const sn = s / 100;
  const ln = l / 100;
  const a = sn * Math.min(ln, 1 - ln);
  const f = (n: number) => {
    const k = (n + h / 30) % 12;

    return Math.round(255 * (ln - a * Math.max(Math.min(k - 3, 9 - k, 1), -1)));
  };

  return `${f(0)} ${f(8)} ${f(4)}`;
}

export function generateBrandPalette(
  hex: string,
): null | Record<string, string> {
  const components = hexToRgbComponents(hex);

  if (!components) return null;

  const [r, g, b] = components;
  const [h, s] = rgbToHsl(r, g, b);
  const exact = `${r} ${g} ${b}`;

  return {
    "100": hslToRgbString(h, s * 0.45, 93),
    "200": hslToRgbString(h, s * 0.65, 86),
    "25": hslToRgbString(h, s * 0.25, 98.5),
    "300": hslToRgbString(h, s * 0.8, 75),
    "400": hslToRgbString(h, s * 0.9, 64),
    "50": hslToRgbString(h, s * 0.3, 97),
    "500": hslToRgbString(h, s * 0.95, 57),
    "600": exact,
    "700": hslToRgbString(h, s, 47),
    "800": hslToRgbString(h, s * 0.9, 38),
    "900": hslToRgbString(h, s * 0.85, 31),
    "950": hslToRgbString(h, s * 0.8, 20),
  };
}
